// components/mdx/InlineNote.jsx
"use client";

export default function InlineNote({ children, className = "" }) {
    return (
        <span
            className={
                "inline-flex items-center gap-1 px-2 py-0.5 rounded bg-blue-100 text-blue-800 text-xs font-medium align-middle ml-1 " +
                className
            }
            style={{ verticalAlign: "middle" }}
            role="note"
        >
            <InfoIcon className="inline-block h-4 w-4" />
            {children}
        </span>
    );
}

function InfoIcon({ className = "" }) {
    return (
        <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            className={className}
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 10v6" />
            <path d="M12 7.5h.01" />
        </svg>
    );
}
